import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getSearchResults = async (searchQueryString, selectedResourceType, allowedResourceTypes, 
    selectedProfile = null, allowedProfiles = [], apiToken = null) => {
    console.log("CALLING SERVER with getsearchresults")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getsearchresults",
            "apiToken": apiToken,
            'contextInfo': { "referenceEntry": true },
            'selectedResourceType': selectedResourceType,
            'allowedResourceTypes': allowedResourceTypes,
            'selectedProfile': selectedProfile,
            'allowedProfiles': allowedProfiles,
            'searchQueryString': searchQueryString.trim()
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is searchResults
            //resp.data = { "success": true, "searchResults": searchResults as Array, "includedResourceTypeValues": includedResourceTypeValues as Array };
            if (resp.data.success) {
                return resp.data.searchResults;
            }
            return resp.data;
        }
        console.log(resp)
        console.log("NO RESPONSE from getsearchresults API call");
    }).catch((error) => { console.log(error); });
};

const getSearchResultsWithIncludedResourceTypes = async (searchQueryString, selectedResourceType, allowedResourceTypes, 
    selectedProfile = null, allowedProfiles = [], apiToken = null, earliestDate = null) => {
    console.log("CALLING SERVER with getsearchresults")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getsearchresults",
            "apiToken": apiToken,
            'contextInfo': { "referenceEntry": true },
            'selectedResourceType': selectedResourceType,
            'allowedResourceTypes': allowedResourceTypes,
            'selectedProfile': selectedProfile,
            'allowedProfiles': allowedProfiles,
            'searchQueryString': searchQueryString.trim(),
            'earliestDate': earliestDate
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is searchResults
            //resp.data = { "success": true, "searchResults": searchResults as Array, "includedResourceTypeValues": includedResourceTypeValues as Array };
            if (resp.data.success) {
                return [resp.data.searchResults, resp.data.includedResourceTypeValues];
            }
            console.log(resp.data);
            return [null, null];
        }
        console.log(resp)
        console.log("NO RESPONSE from getsearchresults API call");
    }).catch((error) => { console.log(error); });
};

export default getSearchResults;
export { getSearchResultsWithIncludedResourceTypes };